<script setup lang="ts">
const { text = 'Loading...' } = defineProps<{ text?: string }>();
</script>

<template>
  <div class="polling__container">
    <div class="loader">
      <div />
      <div />
      <div />
    </div>
    <p class="polling__text">
      {{ text }}
    </p>
  </div>
</template>

<style lang="scss">
.polling {
  position: relative;
  display: none;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 380px);

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &__text {
    @include format-text-style(body-md, 'medium');

    display: block;
    margin: 0 auto;
    text-align: center;
  }
}

.waiting {
  .polling {
    display: flex;

    &__content {
      display: none;
    }
  }
}

[role='timer'] {
  position: absolute;
  top: -1000px;
  left: -1000px;
}

.loader {
  width: 100px;
  display: grid;
  background: radial-gradient(farthest-side, var(--sys-color-primary) 98%, var(--sys-color-surface-container-low))
    center/30px 100% no-repeat;
  --mask:
    radial-gradient(
      12px at left 15px top 50%,
      var(--sys-color-surface-container-low) 95%,
      var(--sys-color-surface-container-low)
    ),
    radial-gradient(12px at center, var(--sys-color-surface-container-low) 95%, var(--sys-color-surface-container-low)),
    radial-gradient(
      12px at right 15px top 50%,
      var(--sys-color-surface-container-low) 95%,
      var(--sys-color-surface-container-low)
    );
  mask: var(--mask);
  -webkit-mask-composite: source-in;
  mask-composite: intersect;
  animation: l2 1s infinite alternate;

  &::before,
  &::after {
    content: '';
    grid-area: 1/1;
    height: 30px;
    aspect-ratio: 1;
    background: var(--sys-color-primary);
    border-radius: var(--sys-radius-round);
  }

  &::after {
    margin-left: auto;
  }
}

@keyframes l2 {
  to {
    width: var(--ref-spacing-8);
  }
}
</style>
